import React from "react";
import RunHistoryDashboard from "../dashboard/dashboard";
import RunHistoryList from "../list/list";

const RunHistoryLanding = () => {
  return (
    <div>
      <div>
        <RunHistoryDashboard />
      </div>
      <div className="mt-4">
        <RunHistoryList />
      </div>
    </div>
  );
};

export default RunHistoryLanding;
